import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  taxesSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../../_shared/schemaHelpers";

export const verifactuCreditNoteSchema: TSchemaBuilder = (t) =>
  documentInfoSchema({
    t,
    documentClass: "CreditNote",
    poErrorKey: "poNumber_is_required",
    dueDateRequired: true,
    enforceDateOrder: true,
  })
    .concat(customerSchema(t))
    .concat(vendorSchema(t))
    .concat(itemsSchema(t))
    .concat(taxesSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema()) as Yup.ObjectSchema<any>;
